import script from "./versionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./versionList.vue?vue&type=script&setup=true&lang=ts"

import "./versionList.vue?vue&type=style&index=0&id=c1ebc32a&scoped=true&lang=scss"
import "./versionList.vue?vue&type=style&index=1&id=c1ebc32a&scoped=true&lang=css"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1ebc32a"]])

export default __exports__